var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIncreaseCollateral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5C4.35067 2.5 0 2.9474 0 5.08073C0 6.7054 2.804 8.43229 8 8.43229C13.196 8.43229 16 6.7054 16 5.08073C16 2.9474 11.6493 2.5 8 2.5ZM8 3.5C13.5373 3.5 15 4.5334 15 5.08073C15 5.87473 12.8867 7.43229 8 7.43229C3.11333 7.43229 1 5.87473 1 5.08073C1 4.5334 2.46267 3.5 8 3.5ZM1.31901 7.76172C1.10101 7.76172 0.90526 7.88292 0.808594 8.07292C0.714594 8.25292 0.666667 8.44828 0.666667 8.65495C0.666667 10.1416 3.23667 11.7214 8 11.7214C12.7633 11.7214 15.3333 10.1416 15.3333 8.65495C15.3333 8.44895 15.286 8.2527 15.1953 8.08203C15.0993 7.8867 14.897 7.76172 14.6797 7.76172C14.5637 7.76172 14.4031 7.82053 14.3138 7.89453C13.1385 8.86386 10.7786 9.44141 8.0013 9.44141H7.9987C5.2207 9.44141 2.8609 8.86323 1.6849 7.89323C1.59223 7.8179 1.43501 7.76172 1.31901 7.76172ZM13.819 9.36849C12.9997 10.0058 11.1593 10.7214 8 10.7214C4.84867 10.7214 3.0095 10.0097 2.1875 9.3737C3.62683 10.0604 5.662 10.4414 8 10.4414C10.3393 10.4414 12.3743 10.0605 13.819 9.36849ZM13.9427 11.237C13.879 11.2496 13.8161 11.2751 13.7591 11.3138C13.2324 11.6705 11.616 12.5 8 12.5C4.39667 12.5 2.76965 11.675 2.23698 11.3203C2.00765 11.167 1.6976 11.2283 1.54427 11.4583C1.39094 11.6883 1.45229 11.999 1.68229 12.1523C2.96763 13.009 5.27 13.5 8 13.5C10.7413 13.5 13.045 13.0059 14.3203 12.1432C14.549 11.9886 14.6091 11.6766 14.4544 11.4479C14.3379 11.2754 14.1337 11.199 13.9427 11.237Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseCollateral);
export default __webpack_public_path__ + "static/media/increase_collateral.19607194c55cd68279a37d9fd79b5788.svg";
export { ForwardRef as ReactComponent };